export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthArea_04.b287f180.jpg";